import http from "infra/http";
import { useQuery } from "react-query";
import { TenantIntegracaoResponse } from "../typings/tenant";

function useGetTenantIntegracoes() {
  const url = `v1/tenants/integracoes`;

  return useQuery(url, async () => {
    const { data } = await http.get<TenantIntegracaoResponse>(url);
    return data;
  });
}

export default useGetTenantIntegracoes;
